import React from 'react';
import Sidebar from '../sidebar/Sidebar';




const Choppy = () => {
    return (
        <div className="dashboard">
            <Sidebar />
                <div className="content-card">
                    {/* Content Goes Here */}
                </div>
            </div>
       
    );
};

export default Choppy;